<ng-container *ngIf="graphData">
    <div
        class="semi-pie-chart"
        [id]="graphId"
        [class.getFullAccessState]="graphData.liteState"
    ></div>
</ng-container>
